import {useAuth} from 'context/authContext';
import styles from './uploader.module.scss';
import Empty from 'assets/images/notFounds/chatPerson.svg';
import CustomBottomSheet from 'components/bottomSheet';
import {useState} from 'react';
import Gallery from 'assets/images/profile/gallery.svg';
type TUploaderProps = {
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  images: Array<IUploadImage>;
};

const Uploader = ({setFile, images}: TUploaderProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const {user} = useAuth();
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {files} = e?.target;
    if (files && files[0]) {
      setFile(prev => [
        {isSelected: prev?.length === 0 ? true : false, file: files?.[0]},
      ]);
    }
  };
  return (
    <>
      <div className={styles['uploader']} onClick={() => setOpenModal(true)}>
        <div className={styles['uploader__img']}>
          <img
            src={
              images && images?.length > 0
                ? URL.createObjectURL(images[0]?.file)
                : user?.profile?.profile_image || Empty
            }
            alt=""
          />
          <i className="icon-Edit bg-primary rounded-full" />
        </div>
      </div>
      <CustomBottomSheet
        isOpen={openModal}
        onDismiss={() => setOpenModal(false)}
      >
        <>
          <div className=" flex justify-between mb-6">
            <p className=" text-sm text-gray-6">انتخاب عکس پروفایل</p>
            <div className=" flex" onClick={() => setFile([])}>
              <p className=" text-sm text-gray-6 ">حذف عکس</p>
              <span className=" icon-trash text-red-1 mx-1"></span>
            </div>
          </div>
          <div className="grid grid-cols-5">
            <input
              type="file"
              id="dropzone-file"
              onChange={handleUpload}
              accept=".jpg, .jpeg"
              className=" hidden"
            />
            <label htmlFor="dropzone-file">
              <div className=" p-6 rounded-full border border-gray-7">
                <img src={Gallery} alt="" />
              </div>
            </label>
          </div>
        </>
      </CustomBottomSheet>
    </>
  );
};
export default Uploader;
